import axios from 'axios';



export const assetCostModelCrud=(data?: any)=>{
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`asset-cost-model/forecast/generator`,data
  );
}
export const assetCostModelHeaderCrud=(data?: any)=>{
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`asset-cost-model/header/edit`,data
  );
}
export const assetCostModelStatistic=()=>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`asset-cost-model/statistic/get`
  );
}
